// Landing-page enhancements reuse existing native purchase forms and PDP controls.
(() => {
  class SaleSticky extends HTMLElement {
    connectedCallback() {
      const main = this.closest('main');
      if (!main) return;
      // Keep fixed positioning outside the overview's clipping and background.
      if (this.parentElement !== main) { main.append(this); return; }
      this.abort = new AbortController();
      this.classList.add('is-enhanced');
      const hero = main.querySelector('.lp-hero');
      const closing = main.querySelector('.lp-media--closing .lp-buy-card');
      const inlinePurchase = main.querySelector('.lp-overview__purchase');
      const update = () => {
        const box = closing?.getBoundingClientRect();
        const closingVisible = box && box.top < innerHeight && box.bottom > 0;
        const inlineBox = inlinePurchase?.getBoundingClientRect();
        const inlineVisible = inlineBox && inlineBox.top < innerHeight && inlineBox.bottom > 0;
        const visible = hero && hero.getBoundingClientRect().bottom <= 0 && !closingVisible && !inlineVisible;
        if (!visible && this.contains(document.activeElement)) {
          const target = closingVisible ? closing : inlineVisible ? inlinePurchase : hero;
          target?.querySelector('button[type="submit"]')?.focus({preventScroll:true});
        }
        this.inert = !visible;
        this.classList.toggle('is-visible', !!visible);
      };
      this.observer = new IntersectionObserver(update);
      [hero,closing,inlinePurchase].filter(Boolean).forEach(element => this.observer.observe(element));
      window.addEventListener('scroll', update, {passive:true,signal:this.abort.signal});
      window.addEventListener('resize', update, {passive:true,signal:this.abort.signal});
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  if (!customElements.get('lp-sale-sticky')) customElements.define('lp-sale-sticky', SaleSticky);
  const initialise = (root = document) => {
    root.querySelectorAll('[data-sale-features]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('.pdp-v2-dark__track');
      const cards = [...track.children];
      const previous = section.querySelector('[data-sale-feature-prev]');
      const next = section.querySelector('[data-sale-feature-next]');
      const controls = section.querySelector('.lp-sale-feature-controls');
      const refresh = () => {
        if (track.scrollWidth <= track.clientWidth + 2 && controls.contains(document.activeElement)) track.focus({preventScroll:true});
        controls.hidden = track.scrollWidth <= track.clientWidth + 2;
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left:direction * (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown',event => { if(event.target===track && ['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1);} });
      track.addEventListener('scroll',refresh,{passive:true});
      new ResizeObserver(refresh).observe(track);
      refresh();
    });
    const source = document.querySelector('[data-lp-countdown]');
    const mirror = document.querySelector('[data-lp-countdown-mirror]');
    if (source && mirror && !mirror.dataset.ready) {
      mirror.dataset.ready = 'true';
      const sync = () => {
        mirror.hidden = source.hidden;
        const values = source.querySelectorAll('[data-countdown-value]');
        mirror.querySelectorAll('[data-countdown-value]').forEach((value,index) => {value.textContent = values[index]?.textContent || '00';});
      };
      new MutationObserver(sync).observe(source,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden']});
      sync();
    }
  };
  initialise();
  document.addEventListener('shopify:section:load',event=>initialise(event.target));
})();
